import { render, staticRenderFns } from "./Profession.vue?vue&type=template&id=45adbe4d&scoped=true&"
import script from "./Profession.vue?vue&type=script&lang=js&"
export * from "./Profession.vue?vue&type=script&lang=js&"
import style0 from "./Profession.vue?vue&type=style&index=0&id=45adbe4d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45adbe4d",
  null
  
)

export default component.exports